import Box from "@material-ui/core/Box";
import { InvestmentOptions } from "../../../api";
import { Colors } from "../../controls/helpers";
import KiwiSaverCalculator from "../../kiwiSaverCalculator/KiwiSaverCalculator";

export default () => (
  <Box px={11} py={3}>
    <KiwiSaverCalculator backgroundColor={Colors.White} investmentOption={InvestmentOptions.LifeCycle} />
  </Box>
);
